import React from 'react';
import { Link } from 'react-router-dom';
import './ProductDetail.css';
import QuickInquiryWidget from '../../components/QuickInquiryWidget';

const WHATSAPP_MESSAGE = "Hi HOPE INTERNATIONAL, I'm interested in your export products. Please share quotation and product details.";
const WHATSAPP_LINK = `https://wa.me/916267592923?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

function GingerPage() {
  return (
    <div className="product-detail-page">
      <QuickInquiryWidget productName="Ginger Powder" botanical="Zingiber officinale" />
      <div className="product-detail-container">
        {/* Product Header */}
        <div className="product-detail-header">
          <h1>Ginger Powder</h1>
          <p className="botanical-name">Zingiber officinale</p>
          <div className="title-underline"></div>
        </div>

        {/* Top Action Buttons */}
        <div className="top-action-buttons">
          <Link to="/request-quote" className="btn-action-primary">Request a Quote</Link>
          <Link to="/request-sample" className="btn-action-secondary">Request a Sample</Link>
          <Link to="/request-coa" className="btn-action-tertiary">Request COA / Specs</Link>
        </div>

        {/* Product Overview */}
        <section className="product-section">
          <h2>Product Overview</h2>
          <p>Ginger Powder is a widely used spice ingredient known for its strong aroma and versatile applications in food, beverages, and wellness formulations. HOPE INTERNATIONAL supplies export-grade Ginger powder for bulk importers and private label brands.</p>
        </section>

        {/* Key Features */}
        <section className="product-section">
          <h2>Key Features</h2>
          <ul className="feature-list">
            <li>Strong natural ginger aroma and flavor</li>
            <li>Fine powder for easy blending and mixing</li>
            <li>Suitable for food, beverage, and wellness brands</li>
            <li>COA available on request (batch-wise)</li>
          </ul>
        </section>

        {/* Typical Applications */}
        <section className="product-section">
          <h2>Typical Applications</h2>
          <div className="applications-grid">
            <div className="application-item">Herbal tea blends and instant drink mixes</div>
            <div className="application-item">Food seasoning and spice blends</div>
            <div className="application-item">Wellness shots and functional beverages</div>
            <div className="application-item">Capsules and nutraceutical formulations</div>
          </div>
        </section>

        {/* Available Specifications */}
        <section className="product-section specs-section">
          <h2>Available Specifications</h2>
          <p className="specs-note">On Request / As per COA</p>
          <div className="specs-table">
            <div className="spec-row">
              <span className="spec-label">Form</span>
              <span className="spec-value">Powder</span>
            </div>
            <div className="spec-row">
              <span className="spec-label">Botanical Name</span>
              <span className="spec-value">Zingiber officinale</span>
            </div>
            <div className="spec-row">
              <span className="spec-label">Part Used</span>
              <span className="spec-value">Rhizome</span>
            </div>
            <div className="spec-row">
              <span className="spec-label">Mesh Size Options</span>
              <span className="spec-value">60 / 80 / 100 mesh (custom available)</span>
            </div>
            <div className="spec-row">
              <span className="spec-label">Moisture</span>
              <span className="spec-value">As per batch COA</span>
            </div>
            <div className="spec-row">
              <span className="spec-label">Shelf Life</span>
              <span className="spec-value">Typically up to 24 months (as per storage conditions)</span>
            </div>
          </div>
        </section>

        {/* Packaging Options */}
        <section className="product-section">
          <h2>Packaging Options</h2>
          <div className="packaging-options">
            <div className="package-item">
              <span className="package-type">Bulk Export Pack</span>
              <span className="package-desc">25 kg kraft paper bag</span>
            </div>
            <div className="package-item">
              <span className="package-type">Retail Pack</span>
              <span className="package-desc">100g matte pouch</span>
            </div>
            <div className="package-item">
              <span className="package-type">Retail Pack</span>
              <span className="package-desc">250g matte pouch</span>
            </div>
          </div>
          <p className="packaging-note">Custom labeling available on request</p>
        </section>

        {/* Documents Available */}
        <section className="product-section">
          <h2>Documents Available</h2>
          <ul className="document-list">
            <li>COA (Certificate of Analysis)</li>
            <li>MSDS / SDS</li>
            <li>Certificate of Origin</li>
            <li>Commercial Invoice & Packing List</li>
            <li>Export documentation support (as per destination requirement)</li>
          </ul>
        </section>

        {/* Industries We Serve */}
        <section className="product-section industries-section">
          <h2>Industries We Serve</h2>
          <div className="industries-list">
            <span>Nutraceutical Manufacturers</span>
            <span>Importers & Distributors</span>
            <span>Food & Beverage Brands</span>
            <span>Private Label Brands</span>
            <span>Ayurveda Companies</span>
          </div>
        </section>

        {/* Related Products */}
        <section className="product-section">
          <h2>Related Products</h2>
          <div className="related-products">
            <Link to="/product/turmeric" className="related-product-link">Turmeric Powder</Link>
            <Link to="/product/ashwagandha" className="related-product-link">Ashwagandha Powder</Link>
            <Link to="/product/moringa" className="related-product-link">Moringa Powder</Link>
            <Link to="/product/amla" className="related-product-link">Amla Powder</Link>
          </div>
        </section>

        {/* Final CTA */}
        <section className="product-cta-section">
          <h3>Want bulk pricing or private label packaging support?</h3>
          <div className="cta-buttons">
            <Link to="/request-quote" className="btn-cta-primary">Request a Quote</Link>
            <Link to="/request-sample" className="btn-cta-secondary">Request a Sample</Link>
            <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" className="btn-cta-whatsapp">WhatsApp Now</a>
          </div>
        </section>
      </div>
    </div>
  );
}

export default GingerPage;
